import {AnalyticsBrowser} from '@segment/analytics-next';

import {ENV} from '@/constants/EnvConstants';
import {IEventIdentifyDataDefinition} from '@/services/segment/models/IdentifyEventModel';
import {
  IEventDataSchema,
  TrackingEvent,
} from '@/services/segment/models/TrackingManagerEventModel';
import {ITrackingService} from '@/services/tracking/ITrackingService';
import {isLocalhost} from '@/utils/environment';

// Never initialized on localhost — `useTrackingManager` routes local dev
// through `mockTrackingService` instead, so this stays a safety net for
// any other place that might import this service directly.
let analytics: AnalyticsBrowser | null = null;

const invalidCharsRegex = /[^a-zA-Z0-9_-]/g;
const leadingUnderscoresRegex = /^_+/;

if (!isLocalhost) {
  const SEGMENT_KEY = ENV.VITE_SEGMENT_WRITE_KEY || '';
  analytics = AnalyticsBrowser.load({writeKey: SEGMENT_KEY});
}

export const segmentService = (): ITrackingService => {
  const trackNavigation = (path: string): void => {
    if (analytics) {
      const sanitizedPath = path
        .replace(invalidCharsRegex, '_')
        .replace(leadingUnderscoresRegex, '');
      analytics.track(`navigate_to_${sanitizedPath}`);
    }
  };

  const trackEvent = (
    eventName: TrackingEvent,
    eventData: IEventDataSchema,
  ): void => {
    if (analytics) {
      analytics.track(eventName, eventData);
    }
  };

  const trackIdentifyEvents = (
    identity: string,
    eventData: IEventIdentifyDataDefinition,
  ) => {
    if (analytics) {
      analytics.identify(identity, eventData);
    }
  };

  const reset = () => {
    if (analytics) {
      analytics.reset().then();
    }
  };

  return {
    trackNavigation,
    trackEvent,
    trackIdentifyEvents,
    reset,
  };
};
